// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3KxLg","vLegacy":"SelectSecondary_vLegacy__1cTVk","error":"SelectSecondary_error__35XRt","disabled":"SelectSecondary_disabled__24QWb"};